import { render, staticRenderFns } from "./settingFrame.vue?vue&type=template&id=226ec6b7"
import script from "./settingFrame.vue?vue&type=script&lang=js"
export * from "./settingFrame.vue?vue&type=script&lang=js"
import style0 from "./settingFrame.vue?vue&type=style&index=0&id=226ec6b7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports